import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getPropertyById, createProperty, updateProperty} from "../services/propertiesService";

import NewProperty from "../pages/NewProperty";
import NewPropertyPhotos from "../pages/NewPropertyPhotos";
import NewPropertyPro from "../pages/NewPropertyPro";
import NewPropertyPreview from "../pages/NewPropertyPreview";
import NewPropertyFinalPreview from "../pages/NewPropertyFinalPreview";
import { uploadImage, uploadVideo } from "../services/cloudinary";

function PropertyWizard({ mode = "create", propertyId }) {

const [step, setStep] = useState(1);
const [propertyData, setPropertyData] = useState({});
const [loading, setLoading] = useState(false);

/* ===============================
   CARGAR PROPIEDAD SI ES EDICIÓN
   =============================== */
const navigate = useNavigate();
useEffect(() => {

if (mode !== "edit" || !propertyId) return;

const loadProperty = async () => {

try {

setLoading(true);

const data = await getPropertyById(propertyId);

if (!data) return;

setPropertyData(data);

} catch (err) {

console.error("Error cargando propiedad", err);

} finally {

setLoading(false);

}

};

loadProperty();

}, [mode, propertyId]);

/* ===============================
   CONTROL DE PASOS
   =============================== */

const nextStep = (data) => {

setPropertyData(prev => ({
...prev,
...data
}));

setStep(prev => prev + 1);

};

const prevStep = () => {

setStep(prev => prev - 1);

};

/* ===============================
   LOADING CUANDO EDITAMOS
   =============================== */

if (loading) {
return <div>Cargando propiedad...</div>;
}

return (

<>

{step === 1 && (
<NewProperty
initialData={propertyData}
onSubmit={nextStep}
/>
)}

{step === 2 && (
<NewPropertyPhotos
initialPhotos={propertyData.images}
initialVideo={propertyData.video}
onBack={prevStep}
onSubmit={nextStep}
/>
)}

{step === 3 && (
<NewPropertyPro
initialData={propertyData}
onBack={prevStep}
onSubmit={nextStep}
/>
)}

{step === 4 && (
<NewPropertyPreview
photos={propertyData.images}
initialData={propertyData}
onBack={prevStep}
onNext={nextStep}
/>
)}

{step === 5 && (
  <NewPropertyFinalPreview
    propertyData={propertyData}
    onBack={prevStep}
    onPublish={async () => {
      const images = [];
      for (const photo of propertyData.images || []) {
        if (typeof photo === 'string') images.push(photo);
        else if (photo.url) images.push(photo.url);
        else if (photo.file) images.push(await uploadImage(photo.file));
      }
      const video = propertyData.video?.file
        ? await uploadVideo(propertyData.video.file)
        : propertyData.video;
      const payload = { ...propertyData, images, video };

      if (mode === "edit") {
        await updateProperty(propertyId, payload);
      } else {
        await createProperty(payload);
      }

      navigate("/mis-publicaciones");
    }}
  />
)}

</>

);

}

export default PropertyWizard;
